import finishCollection from './finish-collection.json';
import reminder from './reminder.json';

export default {
  collection: {
    ...finishCollection,
    ...reminder,
  },
};
